<div>
    <p class="text-color text-bolder">Staff Breaks</p>   
</div>
<app-table-component (onPagination)="onPagination($event)"
[props]="tableConfigAndProps"></app-table-component>
